import { BudgetTab } from './BudgetTab'
import styles from './budgetTrackerStyle.module.scss'

const BudgetTrackerComponent = () => {
    
	return (
		<section className={styles.budgetTrackerSection}>
			<BudgetTab />
		</section>
	)
}

export default BudgetTrackerComponent
